import { permitir_informar_data_de_referencia_do_censo } from "./permitir-marcar-desmarcar-alunos-que-serao-migrados/index";
import { consulta_de_alunos_marcados } from "./consulta-de-alunos-marcados/index";
import { resumo_de_alunos_marcados } from "./resumo-de-alunos-marcados/index";

const marcacao_de_alunos = [
  ...permitir_informar_data_de_referencia_do_censo,
  ...consulta_de_alunos_marcados,
  ...resumo_de_alunos_marcados,
];

export { marcacao_de_alunos };
